import React from 'react';

import { MultiSelect } from '@mantine/core';
import { WeekdayType } from 'utils/weekdays';

const weekdays: Array<{ label: WeekdayType['weekDay']; value: WeekdayType['day'] }> = [
  { value: 1, label: 'Sunday' },
  { value: 2, label: 'Monday' },
  { value: 3, label: 'Tuesday' },
  { value: 4, label: 'Wednesday' },
  { value: 5, label: 'Thursday' },
  { value: 6, label: 'Friday' },
  { value: 7, label: 'Saturday' },
];

const WeekdayFilter = ({
  placeholder,
  className,
  value,
  onChange,
}: {
  placeholder?: string;
  className?: string;
  value: WeekdayType['day'][];
  onChange: (value: WeekdayType['day'][]) => void;
}): JSX.Element => {
  return (
    <MultiSelect
      className={className}
      value={value.map(day => day.toString()).sort()}
      onChange={event => onChange(event.map(day => parseInt(day) as WeekdayType['day']))}
      data={weekdays.map(day => ({ label: day.label, value: day.value.toString() }))}
      placeholder={placeholder}
      clearable
    />
  );
};

export default WeekdayFilter;
